import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchBulkProvisioningJobs } from '@/activityLog/bulkProvisioning/BulkProvisioningApi/bulkProvisioningApi.ts';
import { provisioningQueries } from '@/activityLog/bulkProvisioning/utils/queries.ts';
import { setMinimalPromiseTime } from 'common/utils/setMinimalPromiseTime.ts';
import { BulkProvisioningFilters } from 'atoms/filters/bulk-provisioning.ts';

export const useBulkProvisoningFetch = ({
  fileName,
  orderNumber,
  uploadDateFrom,
  uploadDateTo,
  status,
  source,
  page,
  rowsPerPage,
}: BulkProvisioningFilters & { page: number; rowsPerPage: number }) => {
  const from = uploadDateFrom ? new Date(uploadDateFrom) : null;
  const to = uploadDateTo ? new Date(uploadDateTo) : null;

  const queryResult = useSuspenseQuery({
    queryKey: provisioningQueries.inventory({
      fileName: fileName,
      orderNumber: orderNumber,
      uploadDateFrom: from,
      uploadDateTo: to,
      status,
      source,
      page,
      rowsPerPage,
    }),
    queryFn: ({ signal }) =>
      setMinimalPromiseTime(
        fetchBulkProvisioningJobs(
          {
            page,
            jobsPerRow: rowsPerPage,
            status,
            source,
            uploadDateFrom: from,
            uploadDateTo: to,
            fileName,
            orderNumber,
          },
          signal,
        ),
      ),
  });

  return queryResult;
};
